import { useStringifyQueryFilters } from '@app/src/hooks/queryState'
import { AssessmentExploreViews } from '@app/src/pages/Assessments/AssessmentExplore/AssessmentsExploreScene'
import { ViewTypeName } from '@app/src/pages/ResourceCollection/Collections/ManageRequests/ManageRequestsScene'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import Assessment from '@app/src/types/assessment'
import { AssessmentType } from '@app/src/types/resourceExplorer'
import paths from '@app/src/wf-constants/paths'
import { TypographyProps } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath, useHistory } from 'react-router'
import AssessmentCell from './AssessmentCell'
import ValueCell from './ValueCell'

export type AssessmentResultCellProps = {
  assessment?: Assessment
  noPublicData?: boolean
  hideScore?: boolean | false
} & TypographyProps

const AssessmentResultCell: React.FC<AssessmentResultCellProps> = ({ assessment, noPublicData, hideScore }) => {
  const { formatMessage } = useIntl()
  const { stringifyQueryFilters } = useStringifyQueryFilters()
  const history = useHistory()

  const viewAssessmentLink = (type: AssessmentType) => {
    const isStandard = type === AssessmentType.StandardAssessment && assessment?.assessmentTemplateId

    const path = isStandard
      ? generatePath(paths.exploreAssessment, {
          view: AssessmentExploreViews.Overview,
          assessmentTemplateId: assessment.assessmentTemplateId,
          activePeriod: assessment.periodName,
        })
      : generatePath(paths.baselineAssessment, {
          view: ViewTypeName.Overview,
        })

    const filters = [
      {
        name: 'providerId',
        value: assessment?.providerId,
        operator: Operators.EqualTo,
      },
      {
        name: 'periodName',
        value: assessment?.periodName,
        operator: Operators.EqualTo,
      },
      {
        name: 'assessmentTemplate.questionnaireTemplateId',
        value: assessment?.assessmentTemplate?.questionnaireTemplateId,
        operator: Operators.EqualTo,
      },
    ]

    return stringifyQueryFilters({ url: path, queryParams: { filters } })
  }

  return assessment && !hideScore ? (
    <AssessmentCell
      assessment={assessment}
      noPublicData={noPublicData}
      onClick={() => {
        history.push(viewAssessmentLink(assessment.assessmentTemplate?.assessmentType))
      }}
    />
  ) : (
    <ValueCell
      value={formatMessage({ id: 'schemas.request.notAssessed' })}
      variant="body2"
      color="action.disabled"
      fontSize="1.75rem"
    />
  )
}

export default AssessmentResultCell
